export const BASE_PATH = import.meta.env.VITE_APP_BASE_PATH;
export const ORIGIN = BASE_PATH;
